import React from "react";

import {
  Poll as InferencesIcon,
  Badge as PersonalIdentifiersIcon,
  MedicalServices as MedicalIcon,
  Face as CharacteristicsIcon,
  Fingerprint as BiometricIcon,
  Computer as InternetActivityIcon,
  GpsFixed as LocationIcon,
  PlaylistAddCheck as DefaultIcon,
  School as ProfessionalIcon,
  ShoppingCart as CommercialIcon,
  RemoveRedEye as PhysicalIcon,
  LocalAtm as FinancialIcon,
  Category as CustomIcon,
  Message as CommunicationsIcon,
} from "@mui/icons-material";

import { IconProps } from "@mui/material";

type GroupIconProps = {
  groupName?: string;
  groupKey?: string;
} & IconProps;

export const PIC_GROUP_PERSONAL_IDENTIFIERS = "personal-identifiers";
export const PIC_GROUP_INTERNET_ACTIVITY = "internet-activity";
export const PIC_GROUP_COMMERCIAL_INFORMATION = "commercial-information";
export const PIC_GROUP_FINANCIAL_INFORMATION = "financial-information";
export const PIC_GROUP_BIOMETRIC_INFORMATION = "biometric-info";
export const PIC_GROUP_GEOLOCATION = "geolocation";
export const PIC_GROUP_PHYSICAL_DATA = "physical-and-audio-data";
export const PIC_GROUP_PROTECTED_CLASSIFICATIONS = "protected-classifications";
export const PIC_GROUP_HEALTH_DATA = "health-data";
export const PIC_GROUP_PROFESSIONAL_INFORMATION = "professional-and-education-information";
export const PIC_GROUP_CONSUMER_COMMUNICATIONS = "consumer-communications";
export const PIC_GROUP_INFERENCES = "inferences";
export const PIC_GROUP_CUSTOM = "custom";

const iconMap = {
  [PIC_GROUP_PERSONAL_IDENTIFIERS]: PersonalIdentifiersIcon,
  [PIC_GROUP_INTERNET_ACTIVITY]: InternetActivityIcon,
  [PIC_GROUP_COMMERCIAL_INFORMATION]: CommercialIcon,
  [PIC_GROUP_FINANCIAL_INFORMATION]: FinancialIcon,
  [PIC_GROUP_BIOMETRIC_INFORMATION]: BiometricIcon,
  [PIC_GROUP_GEOLOCATION]: LocationIcon,
  [PIC_GROUP_PHYSICAL_DATA]: PhysicalIcon,
  [PIC_GROUP_PROTECTED_CLASSIFICATIONS]: CharacteristicsIcon,
  [PIC_GROUP_HEALTH_DATA]: MedicalIcon,
  [PIC_GROUP_PROFESSIONAL_INFORMATION]: ProfessionalIcon,
  [PIC_GROUP_CONSUMER_COMMUNICATIONS]: CommunicationsIcon,
  [PIC_GROUP_INFERENCES]: InferencesIcon,
  [PIC_GROUP_CUSTOM]: CustomIcon,
  "Personal Identifiers": PersonalIdentifiersIcon,
  "Internet Activity": InternetActivityIcon,
  "Commercial Information": CommercialIcon,
  "Financial Information": FinancialIcon,
  "Biometric Information": BiometricIcon,
  "Location Information": LocationIcon,
  "Physical and Audio Data": PhysicalIcon,
  "Protected Classifications and Other Personal Characteristics": CharacteristicsIcon,
  "Health Data": MedicalIcon,
  "Professional and Education Information": ProfessionalIcon,
  "Consumer Communications": CommunicationsIcon,
  "Inferences from Other Data": InferencesIcon,
  "Custom Data": CustomIcon,
};

export const GroupIcon: React.FC<GroupIconProps> = ({ groupName, ...rest }) => {
  const IconComponent = iconMap[groupName] ?? DefaultIcon;
  return <IconComponent {...rest} />;
};
